const React = require("react");

function ViewListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 10h16M4 14h16M4 18h16"
  }));
}

module.exports = ViewListIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ViewListIcon.js
 ** module id = 649
 ** module chunks = 0
 **/